import React from 'react';
import { Snackbar, IconButton } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';

const SavedPopup = ({ open, onClose, isError = false, message = null }) => {
  const displayMessage = message || (isError ? 'Error' : 'Saved');
  const icon = isError ? (
    <ErrorIcon style={{ marginRight: '8px', color: 'red' }} />
  ) : (
    <CheckCircleIcon style={{ marginRight: '8px', color: 'green' }} />
  );

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={isError ? 5000 : 2000}
      onClose={onClose}
      message={
        <span style={{ display: 'flex', alignItems: 'center' }}>
          {icon}
          {displayMessage}
        </span>
      }
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={onClose}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      }
      sx={{
        '& .MuiSnackbarContent-root': {
          backgroundColor: isError ? '#d32f2f' : undefined,
        },
      }}
    />
  );
};

export default SavedPopup;